module.exports = __webpack_public_path__ + "static/media/print-logo-6.81f1c8e2.png";